<template>
    <v-dialog persistent no-click-animation v-model="show" width="450">
        <div class="QCBatchPermissionEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('addCallToBatch') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="px-10 py-10">
                <v-form ref="form" v-model="formValid" @submit="submit">
                    <div class="display-flex align-center">
                        <v-text-field
                            v-model="newAddCall"
                            class="input-custom"
                        ></v-text-field>
                        <div class="btn-primary ml-10" @click="submit">{{ $f.tc('add') }}</div>
                    </div>
                </v-form>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormMixin from "@/modules/fptai/mixins/FormMixin";


export default {
    name: 'AddCallToBatchEditor',
    mixins: [DialogPromiseFormMixin, FormMixin],
    data() {
        return {
            newAddCall: '',
            options: [],
            addCallList: []
        }
    },
    methods: {
        open(list, options) {
            this.addCallList = list ? list : []
            this.options = options ? options : []
            this.$refs.form.resetValidation()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm() {
            this.addCallToBatch()
        },
        close() {
            this.show = false
            this.newAddCall = ''
        },
        addCallToBatch() {
            if (this.newAddCall) {
                // check UUID type valid
                if (/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(this.newAddCall)) {
                    this.promise.resolve(this.newAddCall)
                    this.$refs.form.resetValidation()
                    this.close()
                } else {
                    this.$appService.toastError('invalid type UUID')
                }
            } else {
                this.$appService.toastError(this.$f.tc('pleaseEnterAllFields'))
            }
        },
        deleteAssignee(index) {
            if (index > -1) {
                this.addCallList.splice(index, 1)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.QCBatchPermissionEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

table.table-assignees {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;

    tr {
        td {
            border: 1px solid #DADFEC;
            height: 40px !important;
            padding: 0 10px;
        }

        td:last-child {
            width: 67px;
            text-align: center;
        }
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 10px 6px 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 36px !important;
        top: 11px !important;
    }

    .v-input input {
        height: 36px;
    }
}
</style>

